export default {
  customization: {
    actionButton: "Fertig",
    energy: "Strom",
    feedback: "Gibt es etwas, das Sie hinzufügen oder mit uns teilen möchten?",
    formIsBlank: "Das Formular ist leer!",

    PVSystem: "PV Anlage",
    selectSentence: "Wählen Sie die verschiedenen Maßnahmen aus, die Sie durchführen möchten",
    shading: "Beschattung",
    smartShading: "Intelligente Beschattung",
    title: "Konfigurieren Sie Ihr eigenes Modernisierungsszenario",
    wall: "Wand",
    wallInsulation: "Wanddämmung",
    windowExchange: "Fensterwechsel",
    windows: "Fenster",
  },
  goals: {
    noGoals: "Es liegen keine Informationen vor!",
    title: "Modernisierungs-Ziele",
  },
  scenarios: {
    actionButton: "Bericht herunterladen",
    costBenefit: {
      period: "Amortisationszeit",
      saving: "Energiekosteneinsparungen",
      title: "Kosten-Nutzen-Analyse",
      years: "Jahre",
    },
    financingButton: "Finanzierungsmöglichkeiten",
    impact: {
      carbonTitle: "Durchschnittlicher CO₂-Ausstoß",
      energyTitle: "Durchschnittlicher Energieverbrauch",
      postModernization: "Nach Modernisierung",
      saving: "Ersparnisse",
      sectionTitle: "Auswirkung",
      statusQuo: "Status Quo",
    },
    noScenarios: "Es liegen keine Informationen vor!",
    scenario: "Szenario",
    sectionButton: "Alle Modernisierungsszenarien herunterladen",
    title: "Modernisierungsszenarien",
    upgrades: "Aufrüstung",
  },
};
